cv.numberWithCommas = function(x) {
  if(_.isUndefined(x)){
    return '';
  }
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
};
